<ng-container *transloco="let t">
  <div class="modal-header d-flex justify-content-between align-items-center">

        <div class="d-flex justify-content-start align-items-center" (click)="activeModal.dismiss('Cross click')">
          <img src="assets/icons/icons-alt/chevron-left.svg" alt="Back" class="card-body__icon py-1 me-2"/>
          <p class="fs-20 fw-medium"> {{ t('my.entry.personal.info.title') }} </p>
        </div>

        <div class="d-flex justify-content-end align-items-center">
          <img src="assets/icons/icons-alt/edit-2.svg" alt="Edit" class="card-body__icon card-body__icon--size-16 me-2"/>
          <p class="fs-14 color-slate-600"> {{activeEditCount}} {{ t('my.entry.personal.info.editing') }}</p>
        </div>

  </div>


  <div class="modal-body" style="background-color: var(--grey-neutral-50); padding-bottom: 65px;">

      <p class="mb-3 fs-14 color-slate-600">
        {{ t('my.entry.personal.info.modal.text')}}
      </p>

      <div class="section">
        <ng-template [ngTemplateOutlet]="personalInfoInput" [ngTemplateOutletContext]="{
        name: t('app.common.first.name'),
        placeholder: competitor?.firstName ?? '-',
        type: 'firstname'
        }"></ng-template>

        <ng-template [ngTemplateOutlet]="personalInfoInput" [ngTemplateOutletContext]="{
        name: t('app.common.last.name'),
        placeholder: competitor?.lastName ?? '-',
        type: 'lastname'
        }"></ng-template>

        <ng-template [ngTemplateOutlet]="personalInfoInput" [ngTemplateOutletContext]="{
        name: t('app.common.email'),
        placeholder: competitor?.email ?? '-',
        type: 'email'
        }"></ng-template>

        <ng-template [ngTemplateOutlet]="personalInfoInput" [ngTemplateOutletContext]="{
        name: t('app.common.gender'),
        placeholder: competitor?.sex ?? '-',
        type: 'gender'
        }"></ng-template>

        <ng-template [ngTemplateOutlet]="personalInfoInput" [ngTemplateOutletContext]="{
        name: t('app.common.birthDay'),
        placeholder: competitor?.birthday ?? '-',
        type: 'birthDay'
        }"></ng-template>

        <ng-template [ngTemplateOutlet]="personalInfoInput" [ngTemplateOutletContext]="{
        name: t('app.common.category'),
        placeholder: competitor?.categoryLabel ?? '-',
        isEditable: false,
        type: 'category'
        }"></ng-template>

        <ng-template [ngTemplateOutlet]="personalInfoInput" [ngTemplateOutletContext]="{
        name: t('app.common.club'),
        placeholder: competitor?.club ?? '-',
        type: 'club'
        }"></ng-template>
      </div>

  </div>

  <div class="modal-footer pb-4" style="background-color: white;">

    <app-button-alt
      [text]="t('my.entry.personal.info.submit.correction') | uppercase"
      [borderColor]="'var(--teal-500)'"
      [textColor]="'white'"
      [buttonColor]="'var(--teal-500)'"
      (onClickCallback)="onSubmitCorrection()"
      [buttonHeight]="'44px'"
      [isFullWidth]="true"
      additionalClass="mb-2">
    </app-button-alt>
    <app-button-alt
      [text]="t('app.common.cancel') | uppercase"
      [borderColor]="'var(--teal-500)'"
      [textColor]="'var(--teal-500)'"
      [buttonColor]="'transparent'"
      (onClickCallback)="activeModal.close()"
      [buttonHeight]="'44px'"
      [isFullWidth]="true">
    </app-button-alt>

  </div>




  <ng-template #personalInfoInput
               let-name="name" let-placeholder="placeholder" let-edit="isEditable" let-type="type">

    <div class="input-wrapper" [formGroup]="inputForm"> <div class="d-flex justify-content-between align-items-center pb-2">
      <p class="fw-bold">{{ name }}</p>

      <div *ngIf="edit !== false" (click)="onEdit(type)" class="cursor-pointer">
        <img [src]="editStates[type] ? 'assets/icons/icons-alt/undo.svg' : 'assets/icons/icons-alt/edit-2.svg'"
             [alt]="editStates[type] ? 'Undo' : 'Edit'"
             class="card-body__icon py-1" />
      </div>
    </div>

      <div [ngClass]="editStates[type] ? 'input active' : 'input d-flex align-items-center'">
        <p *ngIf="!editStates[type]" class="color-slate-600">
          @switch (type) {
            @case ('birthDay') {
              {{ (placeholder | date: 'dd.MM.yyyy.') ?? '-' }}
            }
            @case ('gender') {
              {{
                placeholder == 1 ? t('app.common.gender.short.1') :
                  placeholder == 2 ? t('app.common.gender.short.2') : '-'
              }}
            }
            @default {
              {{ placeholder ?? '-' }}
            }
          }
        </p>

        <div *ngIf="editStates[type]" class="animate-fade-in">
          <app-input [formControlName]="type" [label]="placeholder" [labelIsVisible]="false"
                     [borderRadiusTopLeft]="'8px'" [borderRadiusTopRight]="'8px'"
                     [borderRadiusBottomLeft]="'8px'" [borderRadiusBottomRight]="'8px'"/>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
